import type { AppState } from "../store/useAppStore";
import { BikeMap } from "../components/map/BikeMap";
import { Dashboard } from "../components/dashboard/Dashboard";
import { HistoryView } from "../components/history/HistoryView";
import { ImportWizard } from "../components/import/ImportWizard";
import { BikesList } from "../components/bikes/BikesList";
import { GpsDataViewer } from "../components/gps/GpsDataViewer";
import { CampaignsList } from "../components/campaigns/CampaignsList";
import { ImpressionJobsList } from "../components/impressions/ImpressionJobsList";
import { ImpressionJobDetail } from "../components/impressions/ImpressionJobDetail";
import { SettingsView } from "../components/settings/SettingsView";
import { FleetsList } from "../components/fleets/FleetsList";
import { UsersList } from "../components/users/UsersList";
import { ReportsJobsList } from "../components/reports/ReportsJobsList";
import { ReportCreateView } from "../components/reports/ReportCreateView";
import { ProfileView } from "../components/profile/ProfileView";

export const PATH_TO_VIEW: Record<string, AppState["currentView"]> = {
  "/dashboard": "dashboard",
  "/live-map": "map",
  "/history": "history",
  "/import": "import",
  "/vehicles": "vehicles",
  "/fleets": "fleets",
  "/users": "users",
  "/gps-data": "gps-data",
  "/campaigns": "campaigns",
  "/impressions": "impression-jobs",
  "/impression-jobs": "impression-job-detail",
  "/reports": "reports",
  "/report-create": "report-create",
  "/settings": "settings",
  "/profile": "profile",
};

export const VIEW_TO_PATH: Record<AppState["currentView"], string> = {
  dashboard: "/dashboard",
  map: "/live-map",
  history: "/history",
  import: "/import",
  vehicles: "/vehicles",
  fleets: "/fleets",
  users: "/users",
  "gps-data": "/gps-data",
  campaigns: "/campaigns",
  "impression-jobs": "/impressions",
  "impression-job-detail": "/impression-jobs",
  reports: "/reports",
  "report-create": "/report-create",
  settings: "/settings",
  profile: "/profile",
};

export function getViewFromPath(pathname: string): AppState["currentView"] {
  return PATH_TO_VIEW[pathname] ?? "dashboard";
}

export const routeElements: Record<AppState["currentView"], React.ReactNode> = {
  dashboard: <Dashboard />,
  map: <BikeMap />,
  history: <HistoryView />,
  import: <ImportWizard />,
  vehicles: <BikesList />,
  fleets: <FleetsList />,
  users: <UsersList />,
  "gps-data": <GpsDataViewer />,
  campaigns: <CampaignsList />,
  "impression-jobs": <ImpressionJobsList />,
  "impression-job-detail": <ImpressionJobDetail />,
  reports: <ReportsJobsList />,
  "report-create": <ReportCreateView />,
  settings: <SettingsView />,
  profile: <ProfileView />,
};
